var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transitionName}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"back-to-ceiling",style:(_vm.customStyle),on:{"click":_vm.backToTop}},[_c('i',{staticClass:"iconfont icon-a-backtop"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }